export default {
    page_title: "Kevi | Quotation fields",
    title: "Quotation fields",
    add_button: "Add",
    back_button: "Back",
    save_button: "Save",
    create_form_title: "Creating field",
    field_form: {
        name_label: "Name",
        type_label: "Type",
    },
    tooltips: {
        edit_field: "Edit field",
        delete_field: "Delete field",
    },
    delete_modal: {
        title: "Would you like to delete",
        body_standard:
            "This action is irreversible, are you sure you want to continue?",
        body_linked: "This field is linked to",
        automations: "the following automations:",
        segments: "the following segments:",
        warning:
            "It is recommended to adjust before removing, continuing now may generate unexpected results.",
    },
    edit_modal: {
        title: "Would you like to edit the name to",
        body: "Make sure the new name is correct before confirming.",
    },
    notifications: {
        added: "Field added",
        deleted: "Quotation field deleted",
        edited: "Quotation field edited",
    },
};
